import clsx from 'clsx';
import React, { PropsWithChildren } from 'react';

import styles from './Typography.module.scss';

interface ITypographyProps {
  type?: 'primary' | 'secondary';
  weight?: 'bold' | 'normal';
  className?: string;
}

const Typography = ({
  children,
  className,
  type = 'primary',
  weight = 'normal',
}: PropsWithChildren<ITypographyProps>) => {
  const elementClassName = clsx(styles.common, styles[type], styles[weight], className);

  return <p className={elementClassName}>{children}</p>;
};

export default Typography;
